import _ from 'underscore';
import SequencerOperation from "models/audioEditor/sequencerOperation/SequencerOperation";
import ti18n from 'i18n!nls/Sequenceri18n';

const CreateNewSpeakerAndAssignToSequencerNodesOperation =  SequencerOperation.extend({
    idAttribute: "id",


    constructor: function(attributes, options) {
        SequencerOperation.apply(this, [attributes, options]);
    },

    execute : function(speakerLabel, _paragraphContainerView, startSequencerNodeToAssign, endSequencerNodeToAssign, arrayOfSequencerNodeToAssign){
        const speakerLabelAlreadyExist = this.getSequencer().isSpeakerWithLabelExist(speakerLabel);
        if(speakerLabelAlreadyExist){
            throw window.getI18n(ti18n, "A_SPEAKER_WITH_THE_SAME_NAME_ALREADY_EXIST")
        }
        const targetSequencerNodes = this._getTargetSequencerNodes(
            startSequencerNodeToAssign,
            endSequencerNodeToAssign,
            arrayOfSequencerNodeToAssign,
        );
        const arrayOfSpeakerWritableSequencerNodes = this._getSpeakerWritableSequencerNodes(targetSequencerNodes);
        if(arrayOfSpeakerWritableSequencerNodes.length === 0){
            return false;
        }
        const sequencerNodeCidArray = this._getSequencerNodeCidArray(arrayOfSpeakerWritableSequencerNodes);
        const {sequencerNodeCidToOldSpeakerId, newSpeakerInfoWithLabel, newSpeakerWasAdded} = this.createNewSpeakerAndAssignToParagraphAnSequencerNodes(arrayOfSpeakerWritableSequencerNodes, speakerLabel);
        this.getSequencer().getHistoryManagement().addSequencerOperationCreateNewSpeakerAndAssignToSequencerNodesOperationLog(sequencerNodeCidArray, speakerLabel, sequencerNodeCidToOldSpeakerId, newSpeakerWasAdded, newSpeakerInfoWithLabel);
        this._notifyParagraphStructureChanged();
        return newSpeakerInfoWithLabel;
    },

    _getTargetSequencerNodes : function(startSequencerNodeToAssign, endSequencerNodeToAssign, arrayOfSequencerNodeToAssign){
        if(Array.isArray(arrayOfSequencerNodeToAssign)){
            return arrayOfSequencerNodeToAssign.reduce((uniqueSequencerNodes, sequencerNode)=>{
                if(sequencerNode && !uniqueSequencerNodes.includes(sequencerNode)){
                    uniqueSequencerNodes.push(sequencerNode);
                }
                return uniqueSequencerNodes;
            }, []);
        }
        if(this.isStartNodeAndEndNodeConnected(startSequencerNodeToAssign, endSequencerNodeToAssign)){
            return this.getArrayOfSequencerNodes(startSequencerNodeToAssign, endSequencerNodeToAssign);
        }
        return [];
    },

    _canPersistSpeakerInfoOnSequencerNode : function(sequencerNode){
        if(!sequencerNode){
            return false;
        }
        if(sequencerNode.isWrapNode && sequencerNode.isWrapNode()){
            return false;
        }
        const audioSegment = sequencerNode.getAudioSegment ? sequencerNode.getAudioSegment() : null;
        return !!(audioSegment && typeof audioSegment.setSpeakerInfo === "function");
    },

    _getSpeakerWritableSequencerNodes : function(arrayOfSequencerNodeToAssign){
        return (arrayOfSequencerNodeToAssign || []).filter((sequencerNode)=>{
            return this._canPersistSpeakerInfoOnSequencerNode(sequencerNode);
        });
    },

    _getSequencerNodeCidArray : function(arrayOfSequencerNodeToAssign){
        return arrayOfSequencerNodeToAssign.map((sequencerNode)=>{
            return sequencerNode.cid;
        });
    },

    _getArrayOfSequencerNodesFromCidArray : function(sequencerNodeCidArray){
        const resolvedSequencerNodes = [];
        for(let i = 0; i < sequencerNodeCidArray.length; i++){
            const sequencerNode = this.getSequencer().getSequencerNodeByNodeCid(sequencerNodeCidArray[i]);
            if(!sequencerNode){
                return null;
            }
            resolvedSequencerNodes.push(sequencerNode);
        }
        return resolvedSequencerNodes;
    },

    createNewSpeakerAndAssignToParagraphAnSequencerNodes : function(arrayOfSequencerNodeToAssign, speakerLabel, preferredSpeakerInfo){
        const sequencerNodeCidToOldSpeakerId = {};
        let newSpeakerInfoWithLabel = preferredSpeakerInfo || this.getSequencer().getSpeakerWithLabel(speakerLabel);
        let newSpeakerWasAdded =  false;
        if(preferredSpeakerInfo){
            newSpeakerInfoWithLabel = this.getSequencer().addAdditionalSpeakerInfo(preferredSpeakerInfo) || preferredSpeakerInfo;
        }else if(!newSpeakerInfoWithLabel){
            newSpeakerInfoWithLabel  = this.getSequencer().createAdditionalSpeakerInfoWithLabel(speakerLabel);
            newSpeakerWasAdded = true;
        }
        arrayOfSequencerNodeToAssign.forEach((sequencerNode)=>{
            sequencerNodeCidToOldSpeakerId[sequencerNode.cid] = sequencerNode.getAudioSegment().getSpeakerInfo()? sequencerNode.getAudioSegment().getSpeakerInfo().getSpeakerId(): null;
            sequencerNode.getAudioSegment().setSpeakerInfo(newSpeakerInfoWithLabel);
        });
        return {sequencerNodeCidToOldSpeakerId, newSpeakerInfoWithLabel, newSpeakerWasAdded};
    },

    undo: function(createNewSpeakerAndAssignToSequencerNodesOperationLog){
        const sequencerNodeCidArray = createNewSpeakerAndAssignToSequencerNodesOperationLog.getSequencerNodeCidArray();
        const arrayOfSequencerNodeToAssign = this._getArrayOfSequencerNodesFromCidArray(sequencerNodeCidArray);
        if(!arrayOfSequencerNodeToAssign){
            console.warn("CreateNewSpeakerAndAssignToSequencerNodesOperation: aborting undo because one or more logged CIDs no longer resolve");
            return;
        }
        const sequencerNodeCidToOldSpeakerId = createNewSpeakerAndAssignToSequencerNodesOperationLog.getSequencerNodeCidToOldSpeakerId();
        const newSpeakerWasAdded = createNewSpeakerAndAssignToSequencerNodesOperationLog.getNewSpeakerWasAdded();
        const newSpeakerInfo = createNewSpeakerAndAssignToSequencerNodesOperationLog.getNewSpeakerInfo();
        arrayOfSequencerNodeToAssign.forEach((sequencerNode)=>{
            const speakerId = sequencerNodeCidToOldSpeakerId[sequencerNode.cid];
            const speakerInfoWithId = this.getSequencer().getSpeakerInfoBySpeakerId(speakerId);
            sequencerNode.getAudioSegment().setSpeakerInfo(speakerInfoWithId);
        });
        if(newSpeakerWasAdded && newSpeakerInfo){
            this.getSequencer().removeAdditionalSpeakerBySpeakerId(newSpeakerInfo.getSpeakerId());
        }
        this._notifyParagraphStructureChanged();
    },

    redo: function(createNewSpeakerAndAssignToSequencerNodesOperationLog){
        const sequencerNodeCidArray = createNewSpeakerAndAssignToSequencerNodesOperationLog.getSequencerNodeCidArray();
        const arrayOfSequencerNodeToAssign = this._getArrayOfSequencerNodesFromCidArray(sequencerNodeCidArray);
        if(!arrayOfSequencerNodeToAssign){
            console.warn("CreateNewSpeakerAndAssignToSequencerNodesOperation: aborting redo because one or more logged CIDs no longer resolve");
            return null;
        }
        const speakerLabel = createNewSpeakerAndAssignToSequencerNodesOperationLog.getSpeakerLabel();
        const newSpeakerInfo = createNewSpeakerAndAssignToSequencerNodesOperationLog.getNewSpeakerInfo();
        const {newSpeakerInfoWithLabel} = this.createNewSpeakerAndAssignToParagraphAnSequencerNodes(arrayOfSequencerNodeToAssign, speakerLabel, newSpeakerInfo);
        this._notifyParagraphStructureChanged();
        return newSpeakerInfoWithLabel;
    },



});

export default CreateNewSpeakerAndAssignToSequencerNodesOperation;
